export default __webpack_public_path__ + "static/media/ENTREVISTA-LUIZ.56dda16e.png";